import { render, staticRenderFns } from "./OutrosChamada.vue?vue&type=template&id=d746dcea&"
import script from "./OutrosChamada.vue?vue&type=script&lang=js&"
export * from "./OutrosChamada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports